'use client';
import {
  Users,
  Settings,
  SquarePen,
  LucideIcon,
  Map,
  HelpCircleIcon,
  HelpingHandIcon,
  FileQuestion,
  Newspaper,
  GitPullRequestCreateArrowIcon  
} from "lucide-react";
import { useUser } from "@/hooks/use-user";


type Menu = {
  href: string;
  label: string;
  active?: boolean;
  icon: LucideIcon;
  submenus?: Menu[];
  requiresAdmin?: boolean;
};

type Group = {
  groupLabel: string;
  menus: Menu[];
};

export function getMenuList(userRole: string): Group[] {
  const { user } = useUser();
  let menu = [
    {
      groupLabel: "Contents",
      menus: [
        {
          href: "/reports",
          label: "Reports",
          icon: SquarePen,
          requiresAuth: true,
          submenus: []
        },
        {
          href: "/map",
          label: "Map",
          requiresAuth: true,
          icon: Map,
        },
        {
          href: "/help",
          label: "Help",
          icon: HelpingHandIcon,
        },
        {
          href: "/faq",
          label: "FAQ",
          icon: HelpCircleIcon,
        },
        {
          href: "/requests/new-report",
          label: "Request New Report",
          requiresAuth: true,
          icon: Newspaper,
        },
        {
          href: "/requests/access",
          label: "Request Access to Report",
          requiresAuth: true,
          icon: FileQuestion,
        },
        {
          href: "/requests/feature",
          label: "Request Feature",
          requiresAuth: true,
          icon: GitPullRequestCreateArrowIcon,
        }
      ]
    },
    {
      groupLabel: "Settings",
      menus: [
        {
          href: "/admin/reports",
          label: "Admin",
          icon: Users,
          requiresAdmin: true
        },
        {
          href: "/account",
          label: "Account",
          requiresAuth: true,
          icon: Settings
        }
      ]
    }
  ];

  if (userRole !== "admin") {
    menu = menu.map(group => {
      group.menus = group.menus.filter(menu => !('requiresAdmin' in menu) || menu.requiresAdmin === false);
      return group;
    });
  }

  if (!user) {
    menu = menu.map(group => {
      group.menus = group.menus.filter(menu => !('requiresAuth' in menu) || menu.requiresAuth === false);
      return group.menus.length ? group : null;
    }).filter(group => group !== null);
  }

  return menu;
}
